<template>
    <div class="cu-panel">
        <div class="cu-panel-header">
            {{trans_heading}}
        </div>
        <div class="cu-panel-body">
            <table class="cu-table">
                <thead>
                    <tr>
                        <th></th>
                        <th class="text-right">Stunden Kostenrechnung</th>
                        <th class="text-right">Stunden Zeiterfassung</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>+ Gearbeitet</td>
                        <td class="text-right">{{data.worked.toLocaleString()}}</td>
                        <td class="text-right">{{data.tracked.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td>+ Abwesend</td>
                        <td class="text-right">{{data.absent.toLocaleString()}}</td>
                        <td class="text-right">{{data.absent.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td>+ Feiertage</td>
                        <td class="text-right">{{data.publicHoliday.toLocaleString()}}</td>
                        <td class="text-right">{{data.publicHoliday.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td>+ Manuelle Überstunden</td>
                        <td class="text-right">{{data.manualOvertime.toLocaleString()}}</td>
                        <td class="text-right">{{data.manualOvertime.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td>- Möglich</td>
                        <td class="text-right">{{data.possible.toLocaleString()}}</td>
                        <td class="text-right">{{data.possible.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <th>= Differenz</th>
                        <th class="text-right">{{data.overtime.toLocaleString()}}</th>
                        <td class="text-right">{{data.trackedOvertime.toLocaleString()}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import BorderedInput from "../Redesign/BorderedInput.vue";

    export default {
        components: {
            BorderedInput
        },
        data() {
            return {
                trans_heading: Worklog.workHourTable.trans_heading,
                data: Worklog.workHourTable.data,
                url: Worklog.workHourTable.url,
                from: Worklog.workHourTable.from,
                to: Worklog.workHourTable.to,
                manage_perms: Worklog.workHourTable.manage_perms,
            }
        },
        mounted() {
        },
        methods: {
            fetchData() {
                axios.get(this.url.replace(':from', this.from).replace(':to', this.to))
                    .then(response => {
                        this.data = response.data
                    })
                    .catch(e => {

                    })
            },
        }
    }
</script>
